import React from 'react'
import BaseInputComponent from './BaseInputComponent'
import Icon from 'react-fa'

import { t } from '../../helpers/translate.js'

class ButtonComponent extends BaseInputComponent {

  render() {

    let buttonName = this.props.as || 'Button';

    if (this.props.keyPath.includes("override_premium")) {
      buttonName = this.props.data.getIn(this.props.keyPath) ? t('Disable Override') : t('Enable Override');
    }

    return <div className={`form-group ${this.state.isInvalid ? t('has-error') : ''}`}>
      <button className="btn button-secondary button-minor" onClick={this.props.buttonAction.bind(this, this.props.keyPath[1])}>
        <Icon name={this.props.iconLabel} className="mr-1" />
        {t(buttonName)}
      </button>
    </div>
  }
}

ButtonComponent.displayName = 'ButtonComponent';
export default ButtonComponent;



// WEBPACK FOOTER //
// ./src/components/common/ButtonComponent.js